import { z } from "zod";

import { DataExportV2ReportType } from "@north-beam/nb-client-side/nb-api-graphql-generated";

import { periodSchema } from "./period-schema";

export const touchpointsReportSchema = z.object({
  type: z.literal(DataExportV2ReportType.TOUCHPOINTS),
  period: periodSchema,
});
